import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import '../styles/WaitlistBanner.css';

const WaitlistBanner = ({ isVisible, onClose }) => {
  const navigate = useNavigate();
  
  if (!isVisible) return null;

  const handleCtaClick = () => {
    navigate('/signup?from=waitlist-gift', { state: { fromWaitlistGift: true } });
  };

  return (
    <div className="waitlist-banner">
      <div className="waitlist-banner-content">
        <div className="banner-message">
          <div className="banner-main-line">
            <div className="banner-icon">
              <FontAwesomeIcon icon={faGift} />
            </div>
            <span className="banner-main-offer">
              Secure Your 1-Year <strong>Free</strong> Yesod Premium
            </span>
          </div>
          <span className="banner-subtitle">
            Create your community now — no commitments or credit card. Claim now, use later.
          </span>
        </div>
        <button className="banner-cta" onClick={handleCtaClick}>
          <span className="cta-main">Secure My Free Year</span>
          <span className="cta-urgency">(Ends Tonight)</span>
        </button>
      </div>
    </div>
  );
};

export default WaitlistBanner;
